import { apiService } from "../../../utils/api/api.service";
import { requestWithErrorHandling } from "../../../utils/error/handle.error";

class BookmarksService {
  private static instance: BookmarksService;

  static getInstance(): BookmarksService {
    if (!BookmarksService.instance) {
      BookmarksService.instance = new BookmarksService();
    }
    return BookmarksService.instance;
  }

  getSavedProducts = (page: number = 1, limit: number = 15) => {
    return requestWithErrorHandling(async () => {
      return await apiService.get<any>("/products/saved", {
        params: { page, limit },
      });
    });
  };

  saveProduct = (productId: string) => {
    return requestWithErrorHandling(async () => {
      return await apiService.post<any>(`/products/${productId}/save`, {});
    });
  };

  unsaveProduct = (productId: string) => {
    return requestWithErrorHandling(async () => {
      return await apiService.delete<any>(`/products/${productId}/save`);
    });
  };

  getLikedProducts = (page: number = 1, limit: number = 15) => {
    return requestWithErrorHandling(async () => {
      return await apiService.get<any>("/products/liked", {
        params: { page, limit },
      });
    });
  };

  likeProduct = (productId: string) => {
    return requestWithErrorHandling(async () => {
      return await apiService.post<any>(`/products/${productId}/like`, {});
    });
  };

  unlikeProduct = (productId: string) => {
    return requestWithErrorHandling(async () => {
      return await apiService.delete<any>(`/products/${productId}/like`);
    });
  };
}

export const bookmarksService = BookmarksService.getInstance();
